module.exports = __webpack_public_path__ + "media/אח.7e502292.mp3";